export default {
	env: 'test',
	mock: false,
	title: '测试',
	imgUrl: 'http://218.195.237.164',
	baseUrl: '', // 测试项目地址
	// baseApi: 'http://192.168.100.15:10600', // 测试api请求地址
	// baseApi: 'http://8.136.141.39:10600', // 测试api请求地址
	baseApi: 'http://gw.iup.test.maxhm.com', // 测试api请求地址
	// baseApi: 'http://192.168.101.0:10600', // 测试api请求地址
	APPID: 'wxb2b90c3586b41f7d',
	APPSECRET: '',
	$cdn: ''
}
